import { render, staticRenderFns } from "./AvailableDocumentsMainView.vue?vue&type=template&id=f80a09c8"
import script from "./AvailableDocumentsMainView.vue?vue&type=script&lang=js"
export * from "./AvailableDocumentsMainView.vue?vue&type=script&lang=js"
import style0 from "./AvailableDocumentsMainView.vue?vue&type=style&index=0&id=f80a09c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports